import { Snackbar, styled } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useI18n } from '../../../shared-lib/i18n/i18n'
import { colors } from '../../../theme'

const StyledToast = styled(Snackbar)(({ itemType }) => `
div {
  background-color: ${itemType === 'error' ? colors.RED800 : colors.GREEN800}
}
`)

interface Props {
  toastData: {
    message: string
    open: boolean
    type?: string
  },
  hideToast: () => void
}

const Toast = observer((props: Props) => {
  const { toastData } = props

  const { s } = useI18n()

  return <>
    <StyledToast
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={toastData.open}
      autoHideDuration={6000}
      className={toastData.type}
      itemType={toastData.type}
      message={s(toastData.message)}
    />
  </>
})

export default Toast